// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1bvob","textarea":"styles_textarea__34q8n"};